import { getParameterTypes } from '@/api/login';
var parameterList = {
  state: {
    financeParameters: []
  },
  mutations: {
    SET_FINANCE_PARAMETERS: function SET_FINANCE_PARAMETERS(state, parameters) {
      state.financeParameters = parameters;
    }
  },
  actions: {
    GetParameterTypes: function GetParameterTypes(_ref) {
      var commit = _ref.commit;
      return new Promise(function (resolve, reject) {
        getParameterTypes().then(function (response) {
          if (!response.data) {
            Promise.Reject('error');
          }
          var data = response.data;
          commit('SET_FINANCE_PARAMETERS', data);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};
export default parameterList;